var React = require('react');

function MinusInline (props) {
    return React.createElement("svg",props,React.createElement("rect",{"x":"4","y":"8.75","width":"12","height":"2.5","rx":"1","fill":"#1565D8"}));
}

MinusInline.defaultProps = {"viewBox":"0 0 20 20","width":"20","height":"20","fill":"none"};

module.exports = MinusInline;

MinusInline.default = MinusInline;
